/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface EmailHandle
 */
export interface EmailHandle {
  /**
   *
   * @type {string}
   * @memberof EmailHandle
   */
  name?: string | null;
  /**
   *
   * @type {string}
   * @memberof EmailHandle
   */
  email?: string | null;
}

/**
 * Check if a given object implements the EmailHandle interface.
 */
export function instanceOfEmailHandle(value: object): value is EmailHandle {
  return true;
}

export function EmailHandleFromJSON(json: any): EmailHandle {
  return EmailHandleFromJSONTyped(json, false);
}

export function EmailHandleFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): EmailHandle {
  if (json == null) {
    return json;
  }
  return {
    name: json["name"] == null ? undefined : json["name"],
    email: json["email"] == null ? undefined : json["email"],
  };
}

export function EmailHandleToJSON(json: any): EmailHandle {
  return EmailHandleToJSONTyped(json, false);
}

export function EmailHandleToJSONTyped(
  value?: EmailHandle | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    name: value["name"],
    email: value["email"],
  };
}
